/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { events } from './events/index';
import { components } from './components/index';

const BrokerRemunerationOtherSection = {
  events,
  components
};

export { BrokerRemunerationOtherSection }